module.exports = __webpack_public_path__ + "static/media/PM79.e31fc6e9.png";